import { FLOW_CHANGE_FLOW_TYPE } from '../../constants/action_types';
import { EEventType } from '../../types/events';
export function changeFlow(flow) {
  return function (dispatch, _getState, context) {
    dispatch({
      type: FLOW_CHANGE_FLOW_TYPE,
      flow: flow
    });
    context.emitter.emit(EEventType.FlowChanged, {
      flow: flow
    });
  };
}